//
// Main Nav functions
//
import Headroom from "headroom.js";

const SITE_HEADER_WRAP_ID = 'site-header-wrap';
const SITE_HEADER_ID = 'site-header';
const NAV_MENU_WRAP_ID = 'js-nav-container';
const NAV_MENU_TRIGGER_ID = 'js-menu-visibility-trigger';

export default class NavMenu {
  constructor() {

    this.siteHeaderWrap = document.getElementById(SITE_HEADER_WRAP_ID);
    this.siteHeader = document.getElementById(SITE_HEADER_ID);
    // Set up nav elements
    this.navMenu = document.getElementById(NAV_MENU_WRAP_ID);
    this.navMenuTrigger = document.getElementById(NAV_MENU_TRIGGER_ID);

    if (!this.navMenu) return;

    // Headroom
    var headroom  = new Headroom(this.siteHeaderWrap);
    headroom.init();

    this.init();
  }

  init() {
    this.addEventHandling();
  }

  /**
   * @public
   */
  toggleNavMenu(event) {
    event.preventDefault();
    let currentTrigger = event.currentTarget;

    // Set class on trigger
    currentTrigger.getAttribute('aria-expanded') == 'false' ? currentTrigger.setAttribute('aria-expanded', "true") : currentTrigger.setAttribute('aria-expanded', "false");
    currentTrigger.classList.toggle('site-header__menu-trigger--open');

    // Show/hide nav
    if(this.navMenu.classList.contains('site-header__menu-wrap--open')) {
      this.navMenu.classList.remove('site-header__menu-wrap--open');
      this.siteHeader.classList.remove('site-header--menu-open');
    } else {
      this.navMenu.classList.add('site-header__menu-wrap--open');
      this.siteHeader.classList.add('site-header--menu-open');
    }
  }

  /**
   * @public
   */
  addEventHandling() {
    // Open/Close menu
    // NB Binding here for future proofing
    this.navMenuTrigger.addEventListener('click', this.toggleNavMenu.bind(this));
  }
}